import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable()
export class BankService {
  url: string | null = null
  constructor (private http: HttpClient) {
    this.url = environment.baseApiUrl + 'admin/'
  }

  get (): Observable<any> {
    return this.http
      .get(
        environment.production
          ? environment.baseApiUrl + 'banks'
          : environment.baseApiUrlTest + 'banks'
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }

  searchName (name: string): Observable<any> {
    return this.http
      .post(
        environment.production
          ? environment.baseApiUrl + 'bank/search'
          : environment.baseApiUrlTest + 'bank/search',
        name
      )
      .pipe(
        map((response: any) => {
          return response['data']
        })
      )
  }
}
